<template>
    <div>
        <!-- <li><a class="mini-text" data-toggle="modal" data-target="#CookiesPage">Cookies</a></li> -->
        <li><a class="mini-text" href="https://optumce.com/about/terms-of-use/" target="_blank">Terms &amp; conditions</a></li>
        <li><a class="mini-text" href="https://optumce.com/about/privacy-policy/" target="_blank">Privacy policy</a></li>
        <li>
            <p class="mini-text">Optum CE ©2023 All rights reserved</p>
        </li>

    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'SlidebarLeft',
    data() {
        return {
            msg: 'Welcome'
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/SlidebarLeft.vue